import { WidgetQuickActions, WidgetChart } from "@components-common/widgets";
import { Page } from "@components-common/layouts";
import { lecturersAreaRoutes } from "./routes";
import { BarChartStatistics, FacetedChart } from "@components-common/charts";
import { Col, Row } from "taltech-styleguide";
import { WidgetConfig } from "../../components-fabric/_types/components";
import { managementAreaRoutes } from "../management/routes";
import { useUserContext } from "../../_runtime/iam/session.context";

const actionsWidget: WidgetConfig & { id: string } = {
  id: "lecturer_shortcuts",
  title: "Shortcuts for common operations",
  subTitle: "",
  Component: WidgetQuickActions,
  items: [
    "create_course",
    "create_building_config",
    "create_space_function",
    "create_floor_type",
    "create_wall_type",
    "create_window_type",
    "create_roof_type",
  ],
};

export const DashboardScreen = () => {
  const { userId } = useUserContext();

  const chartOptions: any = {
    id: "chart_assignment_submissions_by_students",
    firstBarData: {
      name: "Active",
      propName: "activeCount",
    },
    secondBarData: {
      name: "Submitted",
      propName: "submittedCount",
    },
    xAxisProperty: "assignmentTitle",
    title: "",
    subTitle: "",
    urlEndpoint: `analyticsms/course-analytics/get-assignment-submissions-by-user-id-per-assignment?userId=${userId}`,
  };

  const barChartStudentCount: any = {
    id: "chart_student_count_per_course",
    firstBarData: {
      name: "Students",
      propName: "studentCount",
    },
    secondBarData: {
      name: "Lecturers",
      propName: "lecturerCount",
    },
    xAxisProperty: "courseName",
    title: "",
    subTitle: "",
    urlEndpoint: `analyticsms/course-analytics/get-lecturer-student-count-by-course`,
  };

  const widgetChartProps = {
    widgetProps: {
      id: "assignments_statistics",
      title: "Your assignments and students activity",
      subTitle: "",
      className: "",
    },
    chartProps: {
      ChartComponent: FacetedChart,
      chartOptions,
    },
  };

  const widgetBarChartProps = {
    widgetProps: {
      id: "students_statistics",
      title: "Count of students by course",
      subTitle: "",
      className: "",
    },
    chartProps: {
      ChartComponent: FacetedChart,
      chartOptions: barChartStudentCount,
    },
  };
  return (
    <Page title="Dashboard">
      <Row>
        <Col sm="12" md="4">
          <Row className="m-0 h-100">
            <WidgetQuickActions {...actionsWidget} />
          </Row>
        </Col>
        <Col sm="12" md="8">
          <WidgetChart {...widgetBarChartProps} />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm="12" md="6">
          <WidgetChart {...widgetChartProps} />
        </Col>
      </Row>
    </Page>
  );
};
